import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '../../auth.service';
import { PollsService } from '../../pages/service/polls.service';
import { RaceRegistrationService } from '../../pages/service/raceRegistration.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
          @for (item of model; track item; let i = $index) {
            @if (!item.separator) {
              <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
            }
            @if (item.separator) {
              <li class="menu-separator"></li>
            }
          }
        </ul>`
})
export class AppMenu {
    constructor(
        private authService: AuthService,
        private pollsService: PollsService,
        private regService: RaceRegistrationService,
    ) {}
    model: MenuItem[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Home',
                items: [
                    { 
                        label: 'Dashboard', 
                        icon: 'pi pi-fw pi-home', 
                        routerLink: ['/'] 
                    },
                    { 
                        label: 'Community',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/pages/community'] 
                    },
                    { 
                        label: 'Streamer',
                        icon: 'pi pi-fw pi-video',
                        routerLink: ['/pages/media'] 
                    },
                ]
            },
            {
                label: 'Liga',
                items: [
                    {
                        label: 'Regelwerk',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/pages/ruleset']
                    },
                    {
                        label: 'Seasons',
                        icon: 'pi pi-fw pi-car',
                        routerLink: ['/season']
                    },
                    {
                        label: 'Strecken',
                        icon: 'pi pi-fw pi-map',
                        routerLink: ['/circuits']
                    },
                    {
                        label: 'Fahrer',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/pages/player']
                    },
                    {
                        label: 'Teams',
                        icon: 'pi pi-fw pi-sitemap',
                        routerLink: ['/teams']
                    },
                    {
                        label: 'Vergleich',
                        icon: 'pi pi-fw pi-arrow-right-arrow-left',
                        routerLink: ['/comparison']
                    },
                ]
            },
        ];

        if (this.authService.isLoggedIn()) {
            const role = this.authService.getUserRole();
            if (role === 'admin' || role === 'moderator') {
                // Moderators only get the dashboard; the remaining admin pages stay admin-only.
                const adminItems: MenuItem[] = [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-cog',
                        routerLink: ['/pages/admin']
                    },
                ];
                if (role === 'admin') {
                    adminItems.push(
                        {
                            label: 'Stammdaten',
                            icon: 'pi pi-fw pi-database',
                            routerLink: ['/pages/admin/master-data']
                        },
                        {
                            label: 'Saisonplanung',
                            icon: 'pi pi-fw pi-calendar-plus',
                            routerLink: ['/pages/admin/season-planning']
                        },
                        {
                            label: 'Logs',
                            icon: 'pi pi-fw pi-exclamation-circle',
                            routerLink: ['/pages/admin/audit-log']
                        },
                        {
                            label: 'Tools',
                            icon: 'pi pi-fw pi-wrench',
                            routerLink: ['/pages/admin/tools']
                        },
                    );
                }
                this.model.push({ label: 'Admin', items: adminItems });
            }

            // Voting: permanent results entry, plus the live voting entry while a poll is open.
            const votingItems: MenuItem[] = [
                {
                    label: 'Abstimmungs-Ergebnisse',
                    icon: 'pi pi-fw pi-chart-bar',
                    routerLink: ['/pages/voting/results']
                },
            ];
            this.model.push({ label: 'Voting', items: votingItems });

            this.pollsService.getActivePolls().subscribe((polls) => {
                if (polls && polls.length) {
                    votingItems.unshift({
                        label: 'Community-Voting',
                        icon: 'pi pi-fw pi-thumbs-up',
                        routerLink: ['/pages/voting']
                    });
                    // Re-assign so change detection picks up the async addition.
                    this.model = [...this.model];
                }
            });

            // Registration entry appears only while a registration window is open.
            this.regService.getActiveWindows().subscribe((res) => {
                if (res?.windows?.length) {
                    this.model.push({
                        label: 'Anmeldung',
                        items: [
                            {
                                label: 'Zum Rennen anmelden',
                                icon: 'pi pi-fw pi-user-plus',
                                routerLink: ['/pages/registration']
                            },
                        ]
                    });
                    this.model = [...this.model];
                }
            });

            this.model.push({
                label: 'Persönlich',
                items: [
                    {
                        label: 'Mein Dashboard',
                        icon: 'pi pi-fw pi-chart-line',
                        routerLink: ['/pages/member']
                    },
                    {
                        label: 'Logout',
                        icon: 'pi pi-fw pi-sign-out',
                        routerLink: ['/auth/logout']
                    },
                ]
            });
        }else{
            this.model.push(
            {
                label: 'Persönlich',
                items: [
                    { 
                        label: 'Login', 
                        icon: 'pi pi-fw pi-sign-in', 
                        routerLink: ['/auth/login'] 
                    },
                ]
            });
        }
    }
}
